import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'sitemule-user-mfa-dialog',
  templateUrl: './mfa-dialog.component.html',
  styleUrls: ['./mfa-dialog.component.scss']
})
export class MfaDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

}
